<template>
  <section class="ana-clara-highlight" aria-label="Dossiê em destaque: caso Ana Clara">
    <div class="wrap ana-clara-highlight__grid">
      <div>
        <span class="ana-clara-highlight__kicker">EM DESTAQUE / CASO ANA CLARA</span>
        <h2>O nome na defesa.<br>A família à espera.</h2>
        <p>O acórdão do STJ registra Flávio Bolsonaro entre os advogados. Veja o que o recurso pretendia, por que foi rejeitado e o que o documento permite afirmar.</p>
        <RouterLink class="ana-clara-highlight__link" to="/dossies/caso-ana-clara-flavio-bolsonaro">Abrir o caso Ana Clara <span aria-hidden="true">→</span></RouterLink>
      </div>
      <figure>
        <RouterLink to="/dossies/caso-ana-clara-flavio-bolsonaro#documentos" aria-label="Conferir o documento do STJ no caso Ana Clara">
          <picture><source srcset="/documentos/ana-clara-stj-p2-recorte.avif" type="image/avif"><img src="/documentos/ana-clara-stj-p2-recorte.webp" width="940" height="390" alt="Recorte da página 2 do acórdão do STJ, com Flávio Nantes Bolsonaro na lista de advogados." decoding="async"></picture>
        </RouterLink>
        <figcaption>Documento oficial do STJ · página 2 · AgRg no AREsp 2.240.835/RJ.<br>Texto judicial: art. 8º, IV, da Lei 9.610/1998. Recorte sem alteração do conteúdo.</figcaption>
      </figure>
    </div>
  </section>
</template>

<style>
.ana-clara-highlight{padding:clamp(2rem,5vw,4rem) 0;background:#0c2234;color:#fffefa;border-block:5px solid #e6b65e}
.ana-clara-highlight__grid{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr);gap:clamp(2rem,5vw,5rem);align-items:center}
.ana-clara-highlight__kicker{color:#e6b65e;font:700 .72rem/1.5 var(--mono);letter-spacing:.1em}
.ana-clara-highlight h2{margin:1rem 0;font:700 clamp(2.2rem,4.5vw,4.2rem)/1.02 var(--serif);letter-spacing:-.03em;overflow-wrap:anywhere}
.ana-clara-highlight p{max-width:58ch;color:#dbe6eb;line-height:1.6}
.ana-clara-highlight__link{display:inline-flex;align-items:center;justify-content:space-between;gap:1rem;min-height:48px;margin-top:1rem;padding:.85rem 1.2rem;background:#e6b65e;color:#0c2234;font-weight:800;text-decoration:none}
.ana-clara-highlight__link:hover{background:#f3d49c}
.ana-clara-highlight a:focus-visible{outline:3px solid #fffefa;outline-offset:5px}
.ana-clara-highlight figure{min-width:0;margin:0}
.ana-clara-highlight figure a,.ana-clara-highlight img{display:block;width:100%}
.ana-clara-highlight img{height:auto;background:white}
.ana-clara-highlight figcaption{margin-top:.8rem;color:#c7d8e3;font-size:.7rem;line-height:1.6}
@media(max-width:760px){.ana-clara-highlight__grid{grid-template-columns:minmax(0,1fr)}.ana-clara-highlight__link{width:100%}}
</style>
